import { Button, Stack } from "@mui/material";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <Stack direction={"row"} sx={{ mx: 0, p: 0 }}>
      <Button onClick={() => navigate(-1)} sx={{ minWidth: 30 }}>
        <ArrowBackIcon />
      </Button>
    </Stack>
  );
};

export default BackButton;
